/**
 * 学生关联服务
 * 处理用户与学生之间的关联关系
 */
import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/api';

/**
 * 学生关联服务
 */
const studentLinkService = {
  /**
   * 根据当前登录用户获取关联的学生信息
   * @returns {Promise<Object>} 学生关联信息
   */
  async getCurrentStudentLink() {
    return apiClient.get(API_ENDPOINTS.AUTH.ME_STUDENT_LINK);
  },

  /**
   * 根据用户ID获取关联的学生信息
   * @param {number} userId - 用户ID
   * @returns {Promise<Object>} 学生关联信息
   */
  async getStudentLinkByUser(userId) {
    return apiClient.get(`${API_ENDPOINTS.AUTH.USER_STUDENT_LINK}/${userId}`);
  },

  /**
   * 获取当前用户关联的所有学生信息
   * @returns {Promise<Array>} 学生信息数组
   */
  async getCurrentUserStudents() {
    return apiClient.get(API_ENDPOINTS.AUTH.ME_STUDENTS);
  },

  /**
   * 获取用户关联的学生ID列表
   * @param {number} userId - 用户ID
   * @returns {Promise<Array>} 学生ID列表
   */
  async getStudentIdsByUser(userId) {
    const response = await apiClient.get(`${API_ENDPOINTS.AUTH.USER_STUDENT_IDS}/${userId}`);
    return response.student_ids || [];
  },

  /**
   * 创建用户与学生的关联
   * @param {Object} data - 关联数据
   * @param {number} data.user_id - 用户ID
   * @param {number} data.student_id - 学生ID
   * @param {string} data.relationship - 关系类型 (如: parent, guardian, student)
   * @returns {Promise<Object>} 创建结果
   */
  async createStudentLink(data) {
    return apiClient.post(API_ENDPOINTS.AUTH.CREATE_STUDENT_LINK, data);
  },

  /**
   * 删除用户与学生的关联
   * @param {number} linkId - 关联ID
   * @returns {Promise<Object>} 删除结果
   */
  async deleteStudentLink(linkId) {
    return apiClient.delete(`${API_ENDPOINTS.AUTH.DELETE_STUDENT_LINK}/${linkId}`);
  },
};

export default studentLinkService;